import { SORT_TYPES } from './constants';
import { dateCompare } from './dateUtils';

export const EnrollmentConnectionStatusEnum = {
  CONNECTED: 'connected',
  PENDING: 'pending',
  REVOKED: 'revoked',
  DISCONNECTED: 'disconnected',
  EXPIRED: 'expired',
  NONE: 'none',
  ACTIVE: 'Active',
  ENROLLED: 'Enrolled',
  COMPLETED: 'Completed',
  COMPLETE: 'Complete',
};
Object.freeze(EnrollmentConnectionStatusEnum);

export const getEnrollmentConnectionStatusesOrder = () => [
  EnrollmentConnectionStatusEnum.CONNECTED,
  EnrollmentConnectionStatusEnum.PENDING,
  EnrollmentConnectionStatusEnum.REVOKED,
  EnrollmentConnectionStatusEnum.DISCONNECTED,
  EnrollmentConnectionStatusEnum.EXPIRED,
  EnrollmentConnectionStatusEnum.NONE,
  EnrollmentConnectionStatusEnum.ACTIVE,
  EnrollmentConnectionStatusEnum.ENROLLED,
  EnrollmentConnectionStatusEnum.COMPLETED,
];

export const getPendingOrConnectedEnrollmentsByEndDate = (enrollments = []) =>
  enrollments
    .sort((c, d) => dateCompare(c.endDate, d.endDate, SORT_TYPES.DESC))
    .filter(
      c =>
        c.connectionStatus === EnrollmentConnectionStatusEnum.CONNECTED ||
        c.connectionStatus === EnrollmentConnectionStatusEnum.PENDING,
    );



// WEBPACK FOOTER //
// ./src/common/enrollmentUtils.js